import { releaseLandingDomain } from '@/api/admin';
import LoadingWrapper from '@/components/loading-wrapper';
import { Button } from '@/components/ui/button';
import { CardContent } from '@/components/ui/card';
import SettingsWidgetCard from './settings-widget-card';
import { InputGroup, InputGroupInput } from '@/components/ui/input-group';
import { Label } from '@/components/ui/label';
import { AlertTriangleIcon } from 'lucide-react';
import { useState, type FormEvent } from 'react';
import { toast } from 'sonner';

export default function LandingsReleaseWidget() {
	const [zoneName, setZoneName] = useState('');
	const [domainId, setDomainId] = useState('');
	const [isReleasing, setIsReleasing] = useState(false);

	async function handleSubmit(e: FormEvent) {
		e.preventDefault();

		const trimmedZone = zoneName.trim().toLowerCase();
		const parsedDomainId = domainId.trim() ? Number(domainId) : NaN;

		if (!trimmedZone && !Number.isFinite(parsedDomainId)) {
			toast.error('Укажите домен или ID домена');
			return;
		}

		if (!window.confirm('Освободить домен? Это удалит домен, сайты, ссылки и события на landing.')) {
			return;
		}

		setIsReleasing(true);
		try {
			const body = trimmedZone ? { zoneName: trimmedZone } : { domainId: parsedDomainId };
			const result = await releaseLandingDomain(body);
			toast.success(`Домен ${result.zoneName} освобождён`);
			setZoneName('');
			setDomainId('');
		} finally {
			setIsReleasing(false);
		}
	}

	return (
		<SettingsWidgetCard
			id='landings-release'
			icon={AlertTriangleIcon}
			title='Освобождение домена'
			description='Платформенное удаление домена лендинга'
			titleClassName='text-destructive'
			iconWrapperClassName='bg-destructive/15'
			cardClassName='border-destructive/30'
		>
			<CardContent className='px-4 py-4'>
				<form className='flex flex-col gap-4' onSubmit={handleSubmit}>
					<p className='text-xs text-muted-foreground'>
						Удаляет домен, сайты, ссылки и события; снимает CF zone и nginx vhost. Только для platform admin.
					</p>

					<div className='flex flex-col gap-1.5'>
						<Label htmlFor='release-zone-name'>Домен</Label>
						<InputGroup>
							<InputGroupInput
								id='release-zone-name'
								placeholder='promo-example.com'
								value={zoneName}
								onChange={e => setZoneName(e.target.value)}
								disabled={isReleasing}
							/>
						</InputGroup>
					</div>

					<div className='flex flex-col gap-1.5'>
						<Label htmlFor='release-domain-id'>или ID домена</Label>
						<InputGroup>
							<InputGroupInput
								id='release-domain-id'
								type='number'
								inputMode='numeric'
								placeholder='1'
								value={domainId}
								onChange={e => setDomainId(e.target.value)}
								disabled={isReleasing}
							/>
						</InputGroup>
					</div>

					<LoadingWrapper show={isReleasing}>
						<Button type='submit' variant='destructive' className='self-start' disabled={isReleasing}>
							Освободить домен
						</Button>
					</LoadingWrapper>
				</form>
			</CardContent>
		</SettingsWidgetCard>
	);
}
